module.exports = __webpack_public_path__ + "img/联系我们.27acab2f.jpg";